import { roles } from "../constants/roles";

export const constructUserSearchQuery = (userType: string, query: string) => {
  const userTypes = [userType];
  const allFilters: { [key: string]: any }[] = [{ usertype: userTypes }];

  if (userType === roles.provider.value) {
    allFilters.push({ agreement: "true" });
    userTypes.push("temp-provider");
  }

  const searchQuery = {
    query,
    page: {
      size: 20
    },
    sort: {
      firstname: "asc"
    },
    filters: {
      all: allFilters
    }
  };

  return searchQuery;
};

export const constructUserBookingsSearchQuery = (props: any) => {
  const { fieldNames = [], value, pageNumber, size = 20 } = props;

  const searchQuery = {
    query: "",
    page: {
      size,
      current: pageNumber
    },
    sort: {
      date_appointment: "desc"
    },
    filters: {
      any: []
    }
  };

  // Only add filters if there are field names and a search value
  if (fieldNames.length > 0 && value) {
    searchQuery.filters.any = fieldNames.map((fieldName: string) => ({
      [fieldName]: value,
    }));
  }

  return searchQuery;
};
